(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["btw-media-kit"] && !Shopify.designMode) return;
  try {
    
  window.onscroll = function() {stickyHeaderFunction()};
  const stickyHeader = document.querySelector(".header-sub");
  const stickyHeaderPlaceholder = document.querySelector('.header-sub-placeholder');
  const sticky = stickyHeader.offsetTop;
  function stickyHeaderFunction() {
    if (window.pageYOffset > sticky) {
      stickyHeader.classList.add("sticky");
  	stickyHeaderPlaceholder.classList.remove('visibility-hidden');
    } else {
      stickyHeader.classList.remove("sticky");
  	stickyHeaderPlaceholder.classList.add('visibility-hidden');
    }
  }


  const selectors = document.querySelectorAll('.imagery-selector')
  const displayComponents = document.querySelectorAll('.display-display')
  const deviceComponents = document.querySelectorAll('.display-device')
  const lifestyleComponents = document.querySelectorAll('.display-lifestyle')
  const spaCollectionComponents = document.querySelectorAll('.display-spa-collection')
  const allComponents = document.querySelectorAll('.display-display, .display-device, .display-lifestyle, .display-spa-collection')

  const isClickedImagery = (evt) => {
  	for (component of allComponents){
  		component.classList.add('visibility-hidden')
  	}
  	if (evt.target.id == 'imagery-selector-display'){
  		for (component of displayComponents){
  			component.classList.remove('visibility-hidden')
  		}
  	}
  	else if (evt.target.id == 'imagery-selector-device'){
  		for (component of deviceComponents){
  			component.classList.remove('visibility-hidden')
  		}
  	}
  	else if (evt.target.id == 'imagery-selector-lifestyle'){
  		for (component of lifestyleComponents){
  			component.classList.remove('visibility-hidden')
  		}
  	}
  	else if (evt.target.id == 'imagery-selector-spa-collection'){
  		for (component of spaCollectionComponents){
  			component.classList.remove('visibility-hidden')
  		}
  	}
  }
  for (let selector of selectors){
  	selector.addEventListener('click', isClickedImagery)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["btw-press"] && !Shopify.designMode) return;
  try {
    
window.onscroll = function() {stickyHeaderFunction()};
const stickyHeader = document.querySelector(".header-sub");
const stickyHeaderPlaceholder = document.querySelector('.header-sub-placeholder');
const sticky = stickyHeader.offsetTop;
function stickyHeaderFunction() {
  if (window.pageYOffset > sticky) {
    stickyHeader.classList.add("sticky");
	stickyHeaderPlaceholder.classList.remove('visibility-hidden');
  } else {
    stickyHeader.classList.remove("sticky");
	stickyHeaderPlaceholder.classList.add('visibility-hidden');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monq-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.monqHomeHeroTrackingBound) {
    window.monqHomeHeroTrackingBound = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-monq-hero-cta]');
      if (!link) return;
      var hero = link.closest('[data-monq-home-hero]');
      if (!hero || hero.dataset.trackingEnabled !== 'true' || hero.dataset.themeRole !== 'main' || hero.dataset.designMode === 'true') return;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      var parameters = {
        hero_version: 'split_hero_2026_09',
        section_id: hero.dataset.sectionId,
        link_url: link.href,
        link_text: link.textContent.trim(),
        device_group: window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop'
      };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'monq_home_hero_click', parameters);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'monq_home_hero_click' }, parameters));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
